import { CaseDocumentModel } from "./../../models/case-document";
import { backboneViewProperties } from "./../../../decorators/backbone-properties";

const recursiveCategory = require<string>("../partials/recursive-category.html");
const noCategories = require<string>("../partials/no-categories.html");

@backboneViewProperties({
    template : "<div class='category-holder'></div>"
})
export class CaseCategoriesTabView extends Marionette.ItemView<CaseDocumentModel> {

    constructor(options?) {
        super(options);
    }

    public async onShow() {
        let html;
        await this.model.loadDocumentCategories();
        if (this.model.DocumentCategories && this.model.DocumentCategories.length) {
            const data = { Children: this.model.DocumentCategories };
            const tmpl = "<ul class='category-block category-list'>{{>recursive_category}}</ul>";
            html = Mustache.render(tmpl, data, { recursive_category: recursiveCategory });
        } else {
            html = Mustache.render(noCategories, { HasFullText: this.model.HasTranscripts });
        }
        this.$(".category-holder").html(html);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/case-categories.ts